import { HttpService } from "../HttpService";
import { URL } from "enum";
const URL_API = URL.BASE;

const PuntosService = {

	async listar() {
		const respuesta = await HttpService(URL_API).get("/portal-colaborador/comunicaciones-cultura/puntos");
		return respuesta.data;
	},

	async obtenerUrlDescargaMovil() {
		const respuesta = await HttpService(URL_API).get("/portal-colaborador/comunicaciones-cultura/puntos/url-descargar-movil");
		return respuesta.data;
	},

	async getResumen() {
		const respuesta = await HttpService(URL_API).get("/portal-colaborador/comunicaciones-cultura/puntos/resumen");
		return respuesta.data;
	}

};
export default PuntosService;
